import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { ENDPOINTS } from 'src/onboarding/shared/constants/endpoints';
import { ApiService } from 'src/onboarding/shared/services/api.service';

@Injectable({
  providedIn: 'root'
})
export class WebsiteService {

  constructor(
    private apiService: ApiService
  ) {}

  public saveWebsiteUrl(websiteUrl: string, businessEntityId: string): Observable<void> {
    return this.apiService.put(ENDPOINTS.WEBSITE(businessEntityId), {websiteUrl});
  }

}
